<script module>
    
    import * as sanityClient from '@sanity/client'
	import { writable } from 'svelte/store'

    // controls 'visibility' (is selected) of each era
    export let eraVisible = writable([])
    	
	// Initialize Sanity data connection
	export const dataClient = sanityClient.default({
  		projectId: '9miukm40',
  		dataset: 'production',
  		apiVersion: '2021-10-21', // use current UTC date - see "specifying API version"!
  		token: 'skON3PyirxUzZoHB6UswdXJMxF0i1uepZ0RjjN5pPzMfD5DHsTCLbPWkCPEKZJI96C2ZeE0C6dEg80E9q73NKoPwgFwYVn1oAzAh0rpitNxkb61Yxi02tR5a9rj1P3oS8sPXVWZGJSPBUnpyC5L84gpfUVDCsMziSVIA8e83fvdnhvrO2pwZ', // or leave blank for unauthenticated usage
  		useCdn: true, // `false` if you want to ensure fresh data
	})

	export function getData(q){
		return new Promise((res,rej)=>{
			const f = dataClient.fetch(q).then((r)=>{
				console.log('> data::getData(): ',r)
				res(r)
			}).catch(err=>{
				rej(err)
			})
		})
	}

	export function getImage(data){
        console.log(data.type, data.id, data.path)
        return new Promise((res,rej)=>{
			const q = `*[_type == "${data.type}" ${data.id ? '&& _id=="'+data.id+'"':''}]{title, "imageUrl": ${data.path}->url}`
			const f = dataClient.fetch(q).then((r)=>{
                console.log('> data::getImage(): ',r)
			    res(r[0])
			}).catch(rej)
		})
    }

</script>
